export default "__VITE_ASSET__BZmTp$fx__"